import { combineReducers } from 'redux';

import main from './mainReducer';
import outside from './outsideReducer';
import common from './commonReducer';
import simulation from './simulationReducer';
import notice from './noticeReducer';

export default combineReducers({
  main,
  outside,
  common,
  simulation,
  notice
});



// WEBPACK FOOTER //
// ./src/reducers/index.js